<template>
  <Leads />
</template>

<script>
import Leads from '@/modules/leads'

export default {
  components: { Leads },
}
</script>
